import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  input,
  viewChild,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorBase } from '@core/control-value-accessor-base';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sc-input-number',
  imports: [FormsModule, NgxMaskDirective, TranslatePipe, AsyncPipe],
  templateUrl: './input-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideNgxMask(),
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputNumberComponent),
    },
  ],
})
export class InputNumberComponent
  extends ControlValueAccessorBase<number>
  implements AfterViewInit
{
  placeholder = input<string>('');
  mask = input<string>('');
  id = input<string>(null);
  autofocus = input(false);
  public isPhoneNumber = input(false);
  public maxLength = input(null);
  public errorMessage = input<string>(null);

  public isFocused = false;

  inputRef = viewChild<ElementRef>('input');

  ngAfterViewInit() {
    if (this.autofocus()) {
      this.inputRef().nativeElement.focus();
    }
  }

  public onFocus() {
    this.isFocused = true;
  }

  public onBlur() {
    this.isFocused = false;
  }
}
